<script lang="ts">
import { toast } from '@zerodevx/svelte-toast'
import Icon from '@iconify/svelte';

import { _ } from '../i18n.svelte'
import { copyClipbord } from '../util.svelte'

export let text = ''
export let isShowCopyInput = false
export let isShowCopyButotnText = true
</script>
<template lang="pug">
.copy-input__wrapper(class="{isShowCopyInput ? '' : 'hidden-input'}")
    +if('isShowCopyInput')
        input.copy-input__input__wrapper(value="{text}" type="text" on:focus!="{(event) => {event.target.select()}}")
    button.copy-input__copy-button__wrapper(on:click!="{() => { toast.push(_('copied', 'Copied!')); copyClipbord(text) }}")
        Icon(icon="mdi:clipboard-multiple-outline")
        +if('isShowCopyButotnText')
            span.copy-input__copy-button-text__text
                | Copy to Clipboard
</template>
<style lang="scss">
.copy-input__wrapper {
    width: 100%;
    display: flex;
    .copy-input__input__wrapper {
        width: 100%;
        padding: 1rem 2rem;
        font-size: 14px;
        border: 1px solid var(--color-border-line);
        border-radius: 10px 0 0 10px;
    }
    .copy-input__copy-button__wrapper {
        padding: 1rem 2rem;
        display: flex;
        gap: 10px;
        align-items: center;
        border: 1px solid var(--color-border-line);
        border-left: none;
        border-radius: 0 10px 10px 0;
        &:hover {
            background-color: var(--color-gray-light);
        }
    }
    &.hidden-input {
        width: auto;
        .copy-input__copy-button__wrapper {
            width: 15rem;
            display: flex;
            justify-content: center;
            border: 1px solid var(--color-border-line);
            border-radius: 10px;
        }
        
        @media screen and (max-width: 480px) {
            width: 100%;
            .copy-input__copy-button__wrapper {
                width: 100%;
            }
        }
    }
}
</style>